import { render } from "./WCEmployeeSidebar.vue?vue&type=template&id=349abbf4&scoped=true"
import script from "./WCEmployeeSidebar.vue?vue&type=script&lang=js"
export * from "./WCEmployeeSidebar.vue?vue&type=script&lang=js"

import "./WCEmployeeSidebar.vue?vue&type=style&index=0&id=349abbf4&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-349abbf4"]])

export default __exports__